import { AstraParagraph, astraTwMerge, RowType } from '~/astra'
import { PractitionersSelect } from '~/components'
import { useStore } from '~/store/store'
import { IdDate, usePractitionerStatusDefinition } from '~/storm'
import { isDepartmentIncluded } from '~/utils/surgeryActivities'
import { getHolidayStyles } from '~/utils/utils'

import { getFridayStyles } from '../styles'

type Props = {
    label: string
    status: string
}

export function usePractitionersSelectRow({ label, status }: Props): RowType<IdDate> | null {
    const departmentKey = useStore(state => state.appFilters.departmentKey)
    const definition = usePractitionerStatusDefinition({ where: { code: status }, include: { departments: true } })

    if (!isDepartmentIncluded(departmentKey, definition?.departments ?? [])) {
        return null
    }

    return {
        key: label,
        rowHeader: () => <AstraParagraph className="truncate px-2 py-1">{label}</AstraParagraph>,
        cellClassName: ({ date }) => astraTwMerge(getFridayStyles(date), getHolidayStyles(date)),
        cellRender: ({ date }) => <PractitionersSelect label={label} date={date} status={status} />,
    }
}
